<template>
    <div id='BoxCreateForm' class='row'>
        <BoxSideMenu
            :navSteps='steps'
            :activeStep='activeStepIdx'
        />
        <div class='col-9 FormContent' :key='resetIdx'>
            <div class=' CardName row'>
                <h4>{{activeTitle}}</h4>
            </div>
            <div v-if="this.activeStepName === 'create'" class='row' >
                <div class='col-12'>
                    <div class='row RadioGroup'>
                        <div class='col-3'>
                            <Radio
                                label='Not Shipped'
                                store="BuyTracker/BoxCreate"
                                name='shipStatus'
                                id='notShipped'
                                value='notShipped'
                            />
                        </div>
                        <div class='col-3'>
                            <Radio
                                label='Shipped'
                                store="BuyTracker/BoxCreate"
                                name='shipStatus'
                                id='shipped'
                                value='shipped'
                            />
                        </div>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>
                        <TextBox
                            label="License Place/Box Name"
                            store="BuyTracker/BoxCreate"
                            name='boxName'
                            placeholder='Enter Vendor Item ID'
                            :hasErrors='showErrors == false ? false : !validationGroups.create[0].valid'
                            :validationRules="['required']"
                            @validate-field='updateStepValidation'
                        />
                    </div>
                </div>
                <div class='row'>
                    <div class='col-6'>
                        <TextBox
                            label="Tracking Number"
                            store="BuyTracker/BoxCreate"
                            name='trackingNumber'
                            placeholder='Enter Vendor Item ID'
                            :validationRules="['required']"
                            :hasErrors='showErrors == false ? false : !validationGroups.create[1].valid'
                            @validate-field='updateStepValidation'
                        />
                    </div>
                    <div class='col-6 SelectBox'>
                        <Select
                            label='Carrier'
                            store="BuyTracker/BoxCreate"
                            name='carrier'
                            :options='carrierOptions'
                            :hasErrors='showErrors == false ? false : !validationGroups.create[2].valid'
                            :validationRules="['required']"
                            @validate-field='updateStepValidation'
                        />
                    </div>
                </div>
                <div class='row'>
                    <div class='col-6 SelectBox'>
                         <Select
                            label='Origin'
                            store="BuyTracker/BoxCreate"
                            name='origin'
                            :options='originOptions'
                            :hasErrors='showErrors == false ? false : !validationGroups.create[3].valid'
                            :validationRules="['required']"
                            @validate-field='updateStepValidation'
                        />
                    </div>
                    <div class='col-6 SelectBox'>
                        <Select
                            label='Destination'
                            store="BuyTracker/BoxCreate"
                            name='destination'
                            :options='destinationOptions'
                            :hasErrors='showErrors == false ? false : !validationGroups.create[4].valid'
                            :validationRules="['required']"
                            @validate-field='updateStepValidation'
                        />
                    </div>
                </div>
                <div class='row'>
                    <div class='col-3 Spacer'>&nbsp;</div>
                    <div class='col-6 SelectBox'>
                        <Select
                            label='Box Status'
                            store="BuyTracker/BoxCreate"
                            name='boxStatus'
                            :options='boxStatusOptions'
                            :hasErrors='showErrors == false ? false : !validationGroups.create[5].valid'
                            :validationRules="['required']"
                            @validate-field='updateStepValidation'
                        />
                    </div>
                    <div class='col-3 Spacer'>&nbsp;</div>
                </div>
            </div>
            <div v-if="this.activeStepName === 'manage'" class='row'>
                <div class='col-12'>
                    <div class='SectionTitle row'>
                        <h5>{{this.steps[this.activeStepName].formHeader}}</h5>
                    </div>
                    <div class='BoxedItems row'>
                        <!--<ItemListTable
                            classes='col-12'
                            :items='boxedItems.items'
                            :headers='boxedItems.headers'
                        />-->
                        <div class='col-12 ListOfItems'>
                            <List
                                :initialReportState='report'
                                @manage-box='manageBox'
                                @print-label='printLabel'
                                @print-loa='printLoa'
                                @edit-item='editItem'
                                @item-card='itemCard'
                                @open-receipt='openReceipt'
                                @delete='deleteItem'
                            >
                            </List>
                         </div>
                    </div>
                </div>
            </div>
            <div class='row PageFooter'>
                <div class='col-12 text-center'>
                    <DotNav
                        :steps='steps'
                        @update-nav="updateNav"
                    />
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import BoxSideMenu from '../Nav/BoxSideMenu';
    import DotNav from '../Nav/DotNav';
    import Select from '../../../core/form/Select.vue';
    import Radio from '../../../core/form/Radio.vue'
    import TextBox from '../../../core/form/TextBox.vue'
    import DisplayIcon from '../../../icons/DisplayIcon';
    import ItemListTable from './ItemListTable';
    import List from '../../../core/list/List';
    export default{
            name: 'BoxCreateForm',
            components: {
                BoxSideMenu,
                Select,
                DotNav,
                DisplayIcon,
                TextBox,
                Radio,
                ItemListTable,
                List

            },
            data() {
                return {
                    resetIdx: 0,
                    showErrors: false,
                    steps: {
                        create: {
                            order: 0,
                            title: 'Create a New Box',
                            subtitle: 'Box Information',
                            formHeader: 'Purchase Information',
                            errors: true,
                            completed: false,
                            active: true
                        },
                        manage: {
                            order: 1,
                            title: 'What is in the Box?',
                            subtitle: 'Manage Box Contents',
                            formHeader: 'All Items in Box',
                            errors: false,
                            completed: false,
                            active: false
                        }
                    },
                    boxedItems: {},
                    carrierOptions: [],
                    originOptions: [],
                    destinationOptions: [],
                    boxStatusOptions: [],
                    boxValidationGroups: {
                        create: [
                            {name: 'boxName', valid: false},
                            {name: 'trackingNumber', valid: false},
                            {name: 'carrier', valid: false},
                            {name: 'origin', valid: false},
                            {name: 'destination', valid: false},
                            {name: 'boxStatus', valid: false}],
                        manage: []
                    },
                    boxTitles: ['Create a Box', 'Manage Box Contents'],
                   // currentForm: {'name' : 'New Box', 'route': '/buy-tracker/box-create'}
            }},
            computed: {
                activeStepName() {
                    var match = null;
                    for (const [key, value] of Object.entries(this.steps)) {
                        if(value.active == true) {
                            match = key;
                        }
                    }
                    return match;
                },
                activeStepIdx: {
                    get(){
                        var match = this.$store.getters['BuyTracker/BoxCreate/currentPage'] || 0;
                        for (const [key, value] of Object.entries(this.steps)) {
                            console.log('checking - '+ key + ' : ' + value);
                            if(value.order < match){
                                console.log('checking - ' + Object.keys(this.validationGroups[key]));
                                let checker = Object.values(this.validationGroups[key]).findIndex(x => x.valid == false)
                                console.log('checker says - '+ checker)
                                if(checker == -1){
                                    console.log('no errors found');
                                    value.completed = true;
                                    value.errors = false;
                                }else{
                                    value.completed = false;
                                    value.errors = true;
                                }
                            }
                            value.active = (value.order == match) ? true : false
                        }
                        return match;
                    },
                    set(value){
                        return this.$store.dispatch('BuyTracker/BoxCreate/set', {field: 'currentPage', value}) 
                    }
                },
                activeTitle(){return this.boxTitles[this.activeStepIdx]},
                validationGroups:{
                    get () { return this.$store.getters['BuyTracker/BoxCreate/validationGroups']},
                    set (value) { return this.$store.dispatch('BuyTracker/BoxCreate/set', {field: 'validationGroups', value}) },
                },
                formErrors(){
                    let checkGroups = Object.entries(this.steps);
                    console.log('check steps: ' + checkGroups);
                    let foundErrors = false;
                    for(const step in checkGroups){
                        if ((checkGroups[step].findIndex(x => x.errors == true)) != -1){
                            console.log('errors found? - ' + (checkGroups[step][checkGroups[step].findIndex(x => x.errors == true)].title))
                            foundErrors = true;
                        }
                    }
                    return foundErrors;
                },
                report() {
                    var report = this.$store.getters['BuyTracker/ItemCreate/itemReportList'];
                    return report ? report : this.$store.getters['BuyTracker/ItemCreate/itemReportList'];
                },
                createdCollection(){
                    return this.$store.getters['ProductCollection/createdCollection']
                }
            },
            created(){
                console.log('created');
                this.getCarrierOptions();
                this.getOriginOptions();
                this.getDestinationOptions();
                this.getBoxStatusOptions();
                this.getBoxedItems();
                this.loadValidationGroups();
            },
            mounted(){
                console.log('mounted');
                this.$store.dispatch('ProductCollection/addFormToStorage', {name: 'New Box', route: '/buy-tracker/box-create'})
            },
            methods: {
                getCarrierOptions(){
                    this.$api.get('/api/faker', {}).then(response => {
                        this.carrierOptions = [
                            {value: 1, label: 'carrier 1'},
                            {value: 2, label: 'carrier 2'},
                            {value: 3, label: 'carrier 3'},
                            {value: 4, label: 'carrier 4'},
                        ]
                    });
                },
                getOriginOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.originOptions = [
                            {value: 1, label: 'origin 1'},
                            {value: 2, label: 'origin 2'},
                            {value: 3, label: 'origin 3'},
                            {value: 4, label: 'origin 4'}
                        ]
                    });
                },
                getDestinationOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.destinationOptions = [
                            {value: 1, label: 'destination 1'},
                            {value: 2, label: 'destination 2'}
                        ]
                    });
                },
                getBoxStatusOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.boxStatusOptions = [
                            {value: 1, label: 'boxStatus 1'},
                            {value: 2, label: 'boxStatus 2'}
                        ]
                    });
                },
                getBoxedItems() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.boxedItems = {
                            headers:['', '', 'Item Info', 'Item Count', 'Item Cost', 'Date Invoiced', 'Status'],
                            items: {
                                0: [{image:['Image name', '/images/no-listimg.PNG']}, {name:'Vendor Name', location:'Vendor Location'}, '5 Items', '$1,017.42', 'MM/DD/YYYY', 'Open'],
                                1: [{image:['Image name', '/images/no-listimg.PNG']}, {name:'Vendor Name', location:'Vendor Location'}, '5 Items', '$1,017.42', 'MM/DD/YYYY', 'Open'],
                                2: [{image:['Image name', '/images/no-listimg.PNG']}, {name:'Vendor Name', location:'Vendor Location'}, '5 Items', '$1,017.42', 'MM/DD/YYYY', 'Open'],
                                3: [{image:['Image name', '/images/no-listimg.PNG']}, {name:'Vendor Name', location:'Vendor Location'}, '5 Items', '$1,017.42', 'MM/DD/YYYY', 'Open']
                            }
                        }
                    });
                },
                submitForm(){
                    this.$store.dispatch["BuyTracker/ItemCreate/submit"]
                },
                loadValidationGroups(){
                    this.validationGroups = (this.validationGroups == null) ? this.boxValidationGroups : this.validationGroups;
                },
                updateNav({currentStepIdx, newStepIdx}){
                    let currStepRef = this.steps[Object.entries(this.steps).find(step => step[1].order == currentStepIdx)[0]];
                    let newStepRef = this.steps[Object.entries(this.steps).find(step => step[1].order == newStepIdx)[0]];
                    if(newStepRef.errors == true){
                        this.showErrors = true;
                    }
                    currStepRef.errors = 
                       (this.validationGroups[this.activeStepName].findIndex(x => x.valid == false) == -1) ? false : true;
                    currStepRef.active = false;
                    currStepRef.completed = (newStepIdx > currentStepIdx) ? true : false;
                    newStepRef.active = true;
                    this.activeStepIdx = newStepIdx;
                },
                updateStepValidation({field, status}){
                    this.validationGroups[this.activeStepName][this.validationGroups[this.activeStepName].findIndex(x => x.name == field)].valid = status;
                },
                findItem(e){
                    //QNB0PBHEPH006
                    console.log('finditem called');
                    console.log('finditem: '+ e.target.productSkuSearch.value);
                    this.$store.dispatch('BuyTracker/BoxCreate/fetchItem', e.target.productSkuSearch.value);
                    this.resetIdx++;
                },
                onFocus(e){
                    e.target.value = '';
                },
                

                exportItems(){
                    console.log('export items'); //TODO: Export items
                },
                addtoBox(value){
                    console.log('Adding to Box - '+ value); //TODO - Add To Box
                },
                getBoxOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.boxOptions = [
                            {value: 1, label: 'box 1'},
                            {value: 2, label: 'box 2'},
                            {value: 1, label: 'box 3'},
                            {value: 2, label: 'box 4'}
                        ]
                    });
                },
                manageBox(){
                    console.log('manageBox reached!!')
                },
                printLabel(){
                    console.log('Print-label reached!!')
                },
                printLoa(){
                    console.log('printLoa reached!!')
                },
                editItem(payload){
                    console.log('editItem reached!!')
                    this.$store.dispatch('ItemCard/fetchItem', {sku: payload.sku, store: 'ItemCard'})
                        .then(() => {
                            console.log('returned?');
                            //this.saveProduct()
                            })
                        .catch((error) => {
                        //commit('setFetchError', error)
                            console.log('error returning promise: ' + error)
                        });
                },
                itemCard(payload){
                    console.log('itemCard reached!!  '+ payload.sku)

                    this.$store.dispatch('ItemCard/fetchItem', {sku: payload.sku, store: 'ItemCard'})
                        .then(() => {
                            console.log('returned?');
                            //this.saveProduct()
                            })
                        .catch((error) => {
                        //commit('setFetchError', error)
                            console.log('error returning promise: ' + error)
                        });
                },
                openReceipt(){
                    console.log('openReceipt reached!!')
                },
                deleteItem(){
                    console.log('deleteItem reached!!')
                }
            }
        }
</script>
